import store from '@state/store'
import { createConsumer } from '@common/SingleSocketService'

export const providersActions = {
  addNotification: (options) => {
    store.dispatch('notifications/addNotification', options)
  },
}

export const GlobalProviders = (app) => {
  app.config.globalProperties.$notify = (options) => {
    providersActions.addNotification(options)
  }

  Object.defineProperty(app.config.globalProperties, '$cable', {
    get() {
      return createConsumer()
    }
  })
}
